import { checkLogInterviewer } from '@stores/atoms/checkLog';
import { atom } from 'jotai';

export const alreadyEnteredInterviewer = atom<boolean>((get) => {
  return get(checkLogInterviewer);
});
